<script lang="ts">
    import type RewardsAmountFormatter from "@apps/rewards/lib/RewardsAmountFormatter/RewardsAmountFormatter";
    import type RewardsCurrencyFormatter from "@apps/rewards/lib/RewardsCurrencyFormatter";
    import type { RewardsEarningRulesRewardEntity } from "@apps/rewards/modules/EarningRules/models/RewardsEarningRulesEntities";
    import type { TranslationNamespaces } from "@apps/rewards/types";
    import type { URLsBuilder } from "@modules/common_module/URLsBuilder/URLsBuilder";
    import type { GwI18n } from "@modules/i18n/GwI18n/GwI18n";
    import type HTMLSanitizerInterface from "@modules/money/HTMLSanitizer/HTMLSanitizerInterface";

    import RewardsPoints from "../RewardsPoints.svelte";
    import RewardsPointsForAmountReward from "../RewardsWidgetReward/RewardsPointsForAmountReward.svelte";
    import RewardsWidgetReward from "../RewardsWidgetReward/RewardsWidgetReward.svelte";
    import RewardsPlaceOrderStoreCreditsReward from "./RewardsPlaceOrderStoreCreditsReward.svelte";

    //Props
    export let reward: RewardsEarningRulesRewardEntity;
    export let boostCampaignMultiplier: number | undefined;
    export let leaveReviewExtraPoints: number | null;
    export let currencyFormatter: RewardsCurrencyFormatter;
    export let amountFormatter: RewardsAmountFormatter;
    export let urlsBuilder: URLsBuilder;
    export let sanitizer: HTMLSanitizerInterface;
    export let i18n: GwI18n;
    export let namespace: TranslationNamespaces;
    export let pointsNamespace: TranslationNamespaces;
</script>

{#if "amountSpent" in reward && reward.type === "points"}
    <RewardsPointsForAmountReward
        points={boostCampaignMultiplier
            ? reward.points * boostCampaignMultiplier
            : reward.points}
        amount={reward.amountSpent}
        {amountFormatter}
        {currencyFormatter}
        {sanitizer}
        {i18n}
        {namespace}
        {pointsNamespace}
    />
{:else if "amountSpent" in reward && reward.type === "store_credit"}
    <RewardsPlaceOrderStoreCreditsReward
        storeCredits={boostCampaignMultiplier
            ? reward.storeCredit * boostCampaignMultiplier
            : reward.storeCredit}
        amount={reward.amountSpent}
        {currencyFormatter}
        {sanitizer}
        {namespace}
    />
{:else if leaveReviewExtraPoints && "points" in reward}
    <RewardsPoints
        let:value={{ points, pointsNamePlural }}
        points={reward.points}
        {amountFormatter}
        {i18n}
        {pointsNamespace}
    >
        {points} - {points + leaveReviewExtraPoints}
        {pointsNamePlural}
    </RewardsPoints>
{:else}
    <RewardsWidgetReward
        {reward}
        {currencyFormatter}
        {amountFormatter}
        {i18n}
        {namespace}
        {pointsNamespace}
        {urlsBuilder}
        {sanitizer}
    />
{/if}
